import { mapState } from "vuex";
import { Component, Vue } from "vue-property-decorator";
import { IState } from "@/store";
import { ICurrency } from "@/models/constants";
@Component({
  computed: {
    ...mapState({
      brandCurrencies: (state: IState) => state.brand.currencies
    })
  }
})
export default class BrandCurrencies extends Vue {
  // getters
  public brandCurrencies!: ICurrency[];
}
